var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/display-grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,21 C22,21.5522847 21.5522847,22 21,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,3 C2,2.44771525 2.44771525,2 3,2 L21,2 C21.5522847,2 22,2.44771525 22,3 L22,21 Z M8,15.999 L4,15.999 L4,20 L8,20 L8,15.999 Z M14,15.999 L10,15.999 L10,20 L14,20 L14,15.999 Z M20,15.999 L16,15.999 L16,20 L20,20 L20,15.999 Z M8,9.999 L4,9.999 L4,13.999 L8,13.999 L8,9.999 Z M14,9.999 L10,9.999 L10,13.999 L14,13.999 L14,9.999 Z M20,9.999 L16,9.999 L16,13.999 L20,13.999 L20,9.999 Z M8,4 L4,4 L4,7.999 L8,7.999 L8,4 Z M14,4 L10,4 L10,7.999 L14,7.999 L14,4 Z M20,4 L16,4 L16,7.999 L20,7.999 L20,4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/display-grid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-grey",
    mask: "url(#mask-2)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayGrid);
export default __webpack_public_path__ + "static/media/display-grid.d51528df68ab283b1e5d852698e18ac5.svg";
export { ForwardRef as ReactComponent };